var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 81.1144C85.5221 70.7898 87.5709 60.5056 92.7871 52.1893C84.4708 46.9461 74.1462 44.8839 63.7946 47.2426C54.2921 49.4127 46.4341 54.9389 41.1639 62.2713C50.4777 67.3528 57.6618 76.2621 60.2092 87.4224C62.7567 98.5828 60.1419 109.716 53.9552 118.342C61.8806 122.669 71.3561 124.246 80.8585 122.076C91.2101 119.717 99.6073 113.382 104.837 105.052C96.5342 99.8228 90.2262 91.4391 87.8809 81.1144Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2225 87.4225C57.6751 76.2622 50.491 67.3528 41.1772 62.2714C34.9905 70.8977 32.3757 82.031 34.9231 93.1913C37.4706 104.352 44.6547 113.261 53.9685 118.342C60.1552 109.716 62.77 98.5828 60.2225 87.4225Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8808 81.1145C90.2395 91.4391 96.5475 99.8228 104.837 105.053C110.053 96.7362 112.088 86.452 109.743 76.1274C107.384 65.8027 101.076 57.419 92.787 52.1893C87.5708 60.5056 85.5355 70.7898 87.8808 81.1145Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7946 47.2427L80.845 122.009",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.703 76.1005L34.9368 93.1509",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.673 135.709C149.454 123.376 161.219 100.997 152.951 85.7248C144.683 70.4523 119.513 68.0695 96.7315 80.4026C73.9504 92.7357 62.1853 115.114 70.4535 130.387C78.7216 145.659 103.892 148.042 126.673 135.709Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.503 74.4694C134.503 74.4694 131.78 100.955 153.225 106.508",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7058 141.903C92.7058 141.903 93.0697 115.283 71.2208 111.643",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.251 108.88L107.263 119.461",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.918 103.947L115.93 114.541",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.585 99.0275L124.597 109.608",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.017 100.106L97.7605 117.857",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.360f6de8cf5eb7b0a2b29829c2dec8dd.svg";
export { ForwardRef as ReactComponent };